import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { Button, Modal, Row, Col } from 'grab-ui';
import styles from './setup-enterprise-account-modal.less';

const localeKeyPrefix =
  'shopify.settings.manageEmployeeSection.setupEnterpriseAccountModal';

const SetupEnterpriseAccountModal = ({ visible, onCancel, onOk }) => (
  <Modal
    centered
    closable={false}
    maskClosable={false}
    visible={visible}
    className={styles.SetupEnterpriseAccountModal}
    footer={null}
  >
    <div className={styles.Content}>
      <h3>{I18n.t(`${localeKeyPrefix}.header`)}</h3>
      <p>{I18n.t(`${localeKeyPrefix}.message`)}</p>
      <div className={styles.ActionButtonsContainer}>
        <Row type="flex" gutter={16}>
          <Col xs={12}>
            <Button
              block
              className={styles.ActionButton}
              size={'large'}
              onClick={onCancel}
            >
              {I18n.t('v2.commonButton.cancel')}
            </Button>
          </Col>
          <Col xs={12}>
            <Button
              block
              className={styles.ActionButton}
              size={'large'}
              type="primary"
              onClick={onOk}
            >
              {I18n.t(`${localeKeyPrefix}.button.unlinkLabel`)}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  </Modal>
);

SetupEnterpriseAccountModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
};

export default SetupEnterpriseAccountModal;
